import { useMemo } from 'react';
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { formatNumber } from '../../utils/number';

const COLORS = ['#0b2464', '#f5a623', '#10b981', '#6366f1', '#ef4444', '#8b5cf6'];
const FUNNEL_COLORS = ['#94a3b8', '#64748b', '#475569', '#0f172a'];

const LeadTotalsCards = ({ totals }) => {
  if (!totals) return null;

  return (
    <div className="lead-totals-grid" style={{ marginBottom: 16 }}>
      {[
        { label: 'Total Leads', value: formatNumber(totals.total_leads), color: '#0b2464' },
        { label: 'Hari Ini', value: formatNumber(totals.new_today), color: '#059669' },
        { label: 'Direspon', value: formatNumber(totals.responded), color: '#2563eb' },
        { label: 'Pending', value: formatNumber(totals.pending), color: '#d97706' },
      ].map((item) => (
        <div key={item.label} className="kpi-card">
          <div className="kpi-card__label">{item.label}</div>
          <div className="kpi-card__value" style={{ color: item.color }}>{item.value}</div>
        </div>
      ))}
    </div>
  );
};

const LeadSourceChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className="analytics-empty">Belum ada data sumber leads.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={260}>
      <PieChart>
        <Pie
          data={data}
          dataKey="total"
          nameKey="source"
          cx="50%"
          cy="50%"
          outerRadius={90}
          innerRadius={50}
          label={({ source, percent }) => `${source} (${(percent * 100).toFixed(0)}%)`}
        >
          {data.map((_, index) => (
            <Cell key={index} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};

const LeadFunnelChart = ({ data }) => {
  if (!data || data.length === 0 || data.every((d) => d.total === 0)) {
    return <div className="analytics-empty">Belum ada data funnel.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis dataKey="label" tick={{ fontSize: 12 }} stroke="#94a3b8" />
        <YAxis tick={{ fontSize: 12 }} stroke="#94a3b8" />
        <Tooltip formatter={(value) => formatNumber(value)} />
        <Bar dataKey="total" name="Jumlah" radius={[6, 6, 0, 0]}>
          {data.map((_, index) => (
            <Cell key={index} fill={FUNNEL_COLORS[index % FUNNEL_COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

const LeadAnalytics = ({ data }) => {
  if (!data) return null;

  return (
    <>
      <div className="section-card" style={{ marginBottom: 20 }}>
        <div className="section-card__header">
          <h3 className="section-card__title">Ringkasan Leads</h3>
        </div>
        <div className="section-card__body">
          <LeadTotalsCards totals={data.totals} />
          {data.agent_response_hours !== null && data.agent_response_hours !== undefined && (
            <div style={{ fontSize: 13, color: '#64748b', marginTop: 8 }}>
              Rata-rata waktu respons:{' '}
              <strong>{data.agent_response_hours} jam</strong>
            </div>
          )}
        </div>
      </div>

      <div className="analytics-grid">
        <div className="section-card">
          <div className="section-card__header">
            <h3 className="section-card__title">Sumber Leads</h3>
          </div>
          <div className="section-card__body">
            <LeadSourceChart data={data.by_source} />
          </div>
        </div>

        <div className="section-card">
          <div className="section-card__header">
            <h3 className="section-card__title">Funnel Leads</h3>
          </div>
          <div className="section-card__body">
            <LeadFunnelChart data={data.funnel} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadAnalytics;
